import React from "react";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../helper/Preloader";
import Breadcrumb from "../../components/Breadcrumb";
import BreadcrumbImage from "../../components/BreadcrumbImage";
import WhyBecomeSeller from "../../components/WhyBecomeSeller";
import CounterSection from "../../components/CounterSection";
import StepsSection from "../../components/StepsSection";
import TestimonialOne from "../../components/TestimonialOne";
import ShippingOne from "../../components/ShippingOne";
 import BottomFooter from "../../components/BottomFooter";
import HeaderFooter from "../../componentsAmazon/HeaderFooter";
import FooterOne from "../../components/FooterOne";

const BecomeSellerPageAmazon = () => {
  
  return ( 
    <>

      {/* ScrollToTop */}
      <ScrollToTop smooth color='#FA6400' />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */} 
      <HeaderFooter/>
 

      {/* BreadcrumbImage */}
      <BreadcrumbImage />

      {/* WhyBecomeSeller */}
      <WhyBecomeSeller />
  

      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default BecomeSellerPageAmazon;
